import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { pageToPath, pathnameToPage } from "../../routes";
import { BG, BLUE, FONT } from "../theme";
import type { Page } from "../types";
import { CatalogFooter, CatalogHeader } from "../components/Layout";
import { CartDrawer, DessertDetailModal, SetDetailModal } from "../components/Overlays";
import { LocalBusinessSchema } from "../components/LocalBusinessSchema";
import { useBakeryCatalog } from "../context/BakeryCatalogContext";

export default function CatalogLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = pathnameToPage(location.pathname);
  const {
    selectedDessert,
    setSelectedDessert,
    detailQty,
    setDetailQty,
    selectedSet,
    setSelectedSet,
    setQty,
    setSetQty,
    cart,
    cartOpen,
    setCartOpen,
    cartCount,
    cartTotal,
    addToCart,
    addSetToCart,
    updateQty,
    removeItem
  } = useBakeryCatalog();

  const handleNavigate = (page: Page) => {
    navigate(pageToPath(page));
  };

  return (
    <div style={{ backgroundColor: BG, fontFamily: FONT, color: BLUE, minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap');
      `}</style>

      <LocalBusinessSchema />

      <CatalogHeader
        page={currentPage}
        cartCount={cartCount}
        onNavigate={handleNavigate}
        onOpenCart={() => setCartOpen(true)}
      />

      <Outlet />

      <DessertDetailModal
        selectedDessert={selectedDessert}
        quantity={detailQty}
        onDecreaseQty={() => setDetailQty(Math.max(1, detailQty - 1))}
        onIncreaseQty={() => setDetailQty(detailQty + 1)}
        onClose={() => setSelectedDessert(null)}
        onAddToCart={() => {
          if (!selectedDessert) {
            return;
          }
          addToCart(selectedDessert, detailQty);
          setSelectedDessert(null);
        }}
      />

      <SetDetailModal
        selectedSet={selectedSet}
        quantity={setQty}
        onDecreaseQty={() => setSetQty(Math.max(1, setQty - 1))}
        onIncreaseQty={() => setSetQty(setQty + 1)}
        onClose={() => setSelectedSet(null)}
        onAddToCart={() => {
          if (!selectedSet) {
            return;
          }
          addSetToCart(selectedSet, setQty);
          setSelectedSet(null);
        }}
      />

      <CartDrawer
        open={cartOpen}
        cart={cart}
        cartTotal={cartTotal}
        onClose={() => setCartOpen(false)}
        onUpdateQty={updateQty}
        onRemoveItem={removeItem}
      />

      <CatalogFooter />
    </div>
  );
}
